import React, { useEffect, useRef, useState } from "react";
import ExpressionIIStyle from "./expressionII.module.css";
import { trans_diff_name, SelectOPtions } from "../../json/trans_diff_name";
import trans_diff_path from "../../json/trans_diff_path";
import trans_enrich_path_go from "../../json/trans_enrich_path_go";
import trans_enrich_path_kegg from "../../json/trans_enrich_path_kegg";
import {
  Input,
  Select,
  Table,
  Form,
  Button,
  Row,
  Col,
  Carousel,
  Modal,
  Tooltip,
} from "antd";
import { ReactComponent as ExampleIcon } from "../../../../../assets/icon/信封打开.svg";
import { ReactComponent as ExcelDownIcon } from "../../../../../assets/icon/ExcelDown.svg";
import EChartsReact from "echarts-for-react";
import styled from "styled-components";
import http from "../../../../../utils/http";
const { Search } = Input;
const StyledTable = styled(Table)`
  .ant-table-thead > tr > th {
    background-color: #e3f2d9; // 修改表头背景颜色
    color: #333; // 修改表头文字颜色
    font-weight: bold; // 修改表头文字加粗
  }
`;
const StyledTable2 = styled(Table)`
  .ant-table-thead > tr > th {
    background-color: #e3f2d9; // 修改表头背景颜色
    color: #333; // 修改表头文字颜色
    font-weight: bold; // 修改表头文字加粗
  }
`;
const StyledCarousel = styled(Carousel)`
  .slick-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 500px;
  }

  .carousel-item {
    width: 100%;
    height: 500px;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  img {
    max-width: 100%;
  }
`;
const formatToScientificNotation = (num, fractionDigits = 2) => {
  const exponent = Math.floor(Math.log10(Math.abs(num)));
  const mantissa = (num / Math.pow(10, exponent)).toFixed(fractionDigits);
  return `${mantissa}e${exponent >= 0 ? '+' : ''}${exponent}`;
};
function ExpressionII() {
  const [defaultVariety, setDefaultVariety] = useState("CA12DAP_vs_CA9DAP"); // 默认选择的 comparison_of_samples
  const [formVal, setFormVal] = useState({});
  const [form] = Form.useForm();
  const [Pages, setPages] = useState(1);
  const [PageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [TableData, setTableData] = useState([]);
  const [searchText, setSearchText] = useState({});
  const [DiffChartSrc, setDiffChartSrc] = useState({});
const [searchLoading,setSearchLoading]=useState(false)
  const onFinish = (values) => {
    console.log(values)
    setFormVal(values);
    getExpressionII(values, Pages, PageSize);
    GetGoPartII(values);
    GetKeggPartII(values)
    setSearchLoading(true)
  };
  const getExpressionII = (
    values,
    page,
    page_size,
    transcript_id,
    chrome,
    gene_name
  ) => {
    const comparison_of_samples =
      values?.comparison_of_samples || defaultVariety;
    http
      .get(
        `/api/trans/expression/diff/?comparison=${comparison_of_samples}&page=${page}&page_size=${page_size}&transcript_id=${
          transcript_id || ""
        }&chrome=${chrome || ""}Chr01&gene_name=${gene_name || ""}`
      )
      .then((res) => {
        setTotal(res.count);
        setTableData(res.results);
        setDiffChartSrc(trans_diff_path[comparison_of_samples]);
        setSearchLoading(false)
      })
      .catch((err) => {});
  };
  useEffect(() => {
    if (formVal?.comparison_of_samples) {
      console.log(formVal)
      const { transcript_id, chrome, gene_name } = searchText;
      getExpressionII(
        formVal,
        Pages,
        PageSize,
        transcript_id,
        chrome,
        gene_name
      );
      GetGoPartII(formVal);
      setGoImgList(trans_enrich_path_go[formVal.comparison_of_samples]);
      GetKeggPartII(formVal)
      setkeggImgList(trans_enrich_path_kegg[formVal.comparison_of_samples]);
      console.log(trans_enrich_path_go[formVal.comparison_of_samples])

    } else {
      const { transcript_id, chrome, gene_name } = searchText;

      getExpressionII(
        { comparison_of_samples: defaultVariety },
        Pages,
        PageSize,
        transcript_id,
        chrome,
        gene_name
      ); // 默认请求数据
      GetGoPartII({ comparison_of_samples: defaultVariety });
      setGoImgList(trans_enrich_path_go[defaultVariety]);
      GetKeggPartII({ comparison_of_samples: defaultVariety })
      setkeggImgList(trans_enrich_path_kegg[defaultVariety]);

    }
  }, [Pages, PageSize, searchText]);
  // 用来存储选中的下拉框值
  const [selectedVariety, setSelectedVariety] = useState(defaultVariety);
  const [ComOptions,setComOptions]=useState([])
  const handleSelectChange = (value) => {
    setSelectedVariety(value);
    let comop=[]
    const info = trans_diff_name[value];
    info.map(v=>{
      comop.push({
        label:v.sample,
        value:v.sample
      })
    })
    setComOptions(comop)
    // 使用 setFieldsValue 回填表单
    form.setFieldsValue({
      tissue: info ? info[0].tissue : "",
      comparison_of_samples: info ? info[0].sample : "",
    });
  };
  useEffect(() => {
    const info = trans_diff_name[defaultVariety];

    if (info) {
      form.setFieldsValue({
        comparison_of_samples: defaultVariety,
        tissue: info.tissue,
        time: info.time,
      });
    }
  }, [form]);
  const formatNumberWithComma = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  // 分页配置
  const paginationConfig = {
    current: Pages,
    pageSize: PageSize,
    total: total,
    showSizeChanger: true,
    pageSizeOptions: ["10", "25", "50", "100"],
    onChange: (page) => {
      setPages(page);
    },
    onShowSizeChange: (current, size) => {
      setPageSize(size);
      setPages(1); // Reset to first page on page size change
    },
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm(); // 关闭筛选下拉框
    const updatedSearchText = { ...searchText, [dataIndex]: selectedKeys[0] }; // 更新搜索条件
    setSearchText(updatedSearchText);
  };

  const handleReset = (clearFilters, dataIndex) => {
    clearFilters();
    const updatedSearchText = { ...searchText };
    delete updatedSearchText[dataIndex]; // 移除该字段的搜索条件
    setSearchText(updatedSearchText);
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters, dataIndex)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </div>
      </div>
    ),
    filterIcon: (filtered) => (
      <span
        style={{
          color: filtered ? "#1890ff" : undefined,
          cursor: "pointer",
        }}
      >
        🔍
      </span>
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
  });

  const DiffColums = [
    {
      key: "2",
      title: "Transcript-id",
      dataIndex: "transcript_id",
      align: "center",
      ...getColumnSearchProps("transcript_id"),
    },
    {
      key: "3",
      title: "Comparison of samples",
      dataIndex: "comparison_of_samples",
      align: "center",
    },
    {
      key: "4",
      title: "Tissue",
      dataIndex: "tissue",
      align: "center",
    },
    {
      key: "5",
      title: "Time",
      dataIndex: "time",
      align: "center",
    },
    {
      key: "6",
      title: "Log2 Fold change",
      dataIndex: "log2foldchange",
      align: "center",
      render: (index, item) => {
        return <span>{formatToScientificNotation(index)}</span>;
      },
    },
    {
      key: "7",
      title: "padj",
      dataIndex: "padj",
      align: "center",
      render: (index, item) => {
        return <span>{formatToScientificNotation(index)}</span>;
      },
    },
    {
      key: "8",
      title: "Chrome",
      dataIndex: "chrome",
      align: "center",
      ...getColumnSearchProps("chrome"),
    },
    {
      key: "9",
      title: "Start",
      dataIndex: "start",
      align: "center",
      render: (index, item) => {
        return <span>{formatNumberWithComma(index)}</span>;
      },
    },
    {
      key: "10",
      title: "End",
      dataIndex: "end",
      align: "center",
      render: (index, item) => {
        return <span>{formatNumberWithComma(index)}</span>;
      },
    },
    {
      key: "11",
      title: "Transcript length",
      dataIndex: "transcript_length",
      align: "center",
      render: (index, item) => {
        return <span>{formatNumberWithComma(index)}</span>;
      },
    },
    {
      key: "12",
      title: "Gene name",
      dataIndex: "gene_name",
      align: "center",
      ...getColumnSearchProps("gene_name"),
    },
    {
      key: "13",
      title: "Annotation",
      dataIndex: "annotation",
      align: "center",
    },
  ];
  const [GoImgList, setGoImgList] = useState([]);
  const [goColums, setGoColums] = useState([]);
  const [goData, setGoData] = useState([]);
  const GoSwiperRef = useRef(null);
  const GoSwiperChange = (index) => {
    return index == GoSwiperCurrent ? "2px solid #BDF7C1" : "2px solid #fff";
  };
  const [GoSwiperCurrent, setGoSwiperCurrent] = useState(0);
  const [GeneIdText, setGeneIdText] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [goKey, setGoKey] = useState("");
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const GetGoPartII = (values, go_pages, go_page_size) => {
    setGoImgList(trans_enrich_path_go[values.comparison_of_samples]);
    http
      .get(
        `/api/trans/expression/diff/go/?comparison=${values.comparison_of_samples}`
      )
      .then((res) => {
        let TempleColumsGo = [];
        Object.keys(res[0]).map((key) => {
          TempleColumsGo.push({
            key: key,
            title: key,
            dataIndex: key, 
            align: "center",
            render: (index, item) => {
              if (key == "gene_id") {
                return (
                  <p
                    onClick={() => {
                      showModal();
                      setGeneIdText(index);
                      setGoKey(key);
                    }}
                    className={ExpressionIIStyle.Table_overHidden}
                  >
                    {index}
                  </p>
                );
              } else {
                return <span>{index}</span>;
              }
            },
          });
        });
        setGoColums(TempleColumsGo);
        setGoData(res);
      })
      .catch((err) => {});
  };
  const [keggImgList, setkeggImgList] = useState([]);
  const [keggColums, setkeggColums] = useState([]);
  const [keggData, setkeggData] = useState([]);
  const keggSwiperRef = useRef(null);
  const keggSwiperChange = (index) => {
    return index == keggSwiperCurrent ? "2px solid #BDF7C1" : "2px solid #fff";
  };
  const [keggSwiperCurrent, setkeggSwiperCurrent] = useState(0);
  const [GeneIdKeggText, setGeneIdKeggText] = useState("");
  const [isModalOpenKegg, setIsModalOpenKegg] = useState(false);
  const [keggKey, setKeggKey] = useState("");
  const showModalKegg = () => {
    setIsModalOpenKegg(true);
  };
  const handleOkKegg = () => {
    setIsModalOpenKegg(false);
  };
  const handleCancelKegg = () => {
    setIsModalOpenKegg(false);
  };
  const GetKeggPartII = (values) => {
    setkeggImgList(trans_enrich_path_kegg[values.comparison_of_samples]);
    http
      .get(
        `/api/trans/expression/diff/kegg/?comparison=${values.comparison_of_samples}`
      )
      .then((res) => {
        let TempleColumsGo = [];
        Object.keys(res[0]).map((key) => {
          TempleColumsGo.push({
            key: key,
            title: key,
            dataIndex: key,
            align: "center",
            render: (index, item) => {
              if (key == "gene_id") {
                return (
                  <p
                    onClick={() => {
                      showModalKegg();
                      setGeneIdKeggText(index);
                      setKeggKey(key);
                    }}
                    className={ExpressionIIStyle.Table_overHidden}
                  >
                    {index}
                  </p>
                );
              } 
              else if(key=='hyperlink'){
                return (
                  <p
                    onClick={() => {
                      showModalKegg();
                      setGeneIdKeggText(index);
                      setKeggKey(key);
                    }}
                    className={ExpressionIIStyle.Table_overHidden}
                  >
                    {index}
                  </p>
                );
              }else if(key=='pvalue'){
                return <span>{formatToScientificNotation(index)}</span>;
              } else if(key=='padj'){
                return <span>{formatToScientificNotation(index)}</span>;
              }
              else {
                return <span>{index}</span>;
              }
            },
          });
        });
        setkeggColums(TempleColumsGo);
        setkeggData(res);
      })
      .catch((err) => {});
  };
  return (
    <div className={ExpressionIIStyle.ExpAnaly_Diffrent}>
      <div className={ExpressionIIStyle.ExpAnaly_Diffrent_title}>
        <p>2、Diffrent expression analysis</p>
      </div>
      <div className={ExpressionIIStyle.ExpAnaly_Diffrent_content_form}>
        <Form
          form={form}
          onFinish={onFinish}
          style={{ width: "90%", margin: "auto" }}
        >
         
          <Row>
            <Col span={8}>
            <Form.Item
                label={<span style={{ fontWeight: "bold" }}>Project</span>}
                name="project"
              >
                <Select  style={{ width: "80%" }}  
               defaultValue={'Comparative Transcriptome of Lotus Seed Cotyledon Development'}
                placeholder="Please select"
                options={SelectOPtions}
                onChange={handleSelectChange}

                />
              </Form.Item>
            </Col>
            <Col span={8}>
            <Form.Item
                label={
                  <span style={{ fontWeight: "bold" }}>
                    Comparison of samples
                  </span>
                }
                name="comparison_of_samples"
                initialValue={selectedVariety}
              >
                {
                  console.log(ComOptions.length!=0?ComOptions:trans_diff_name['Comparative Transcriptome of Lotus Seed Cotyledon Development'].map(v=>{
                    return {
                      value: v.sample,
                      label: v.sample
                    }
                  }))
                }
                <Select
                  style={{ width: "80%" }}
                  options={ComOptions.length!=0?ComOptions:trans_diff_name['Comparative Transcriptome of Lotus Seed Cotyledon Development'].map(v=>{
                    return {
                      value: v.sample,
                      label: v.sample
                    }
                  })}
                 
                />
              </Form.Item>
            </Col>
            <Col span={8}>
            <Form.Item
                label={<span style={{ fontWeight: "bold" }}>Tissue</span>}
                name="tissue"
              >
                <Input defaultValue={'Cotyledon VS Cotyledon'} style={{ width: "80%" }} />
              </Form.Item>
            </Col>
          </Row>
         
          <Form.Item
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <Button
              style={{
                margin: "0 100px",
                width: "150px",
                background: "#076A09",
                border: "none",
                color: "white",
              }}
              htmlType="submit"
              loading={searchLoading}
            >
              Search
            </Button>
            <Button style={{ margin: "0 100px", width: "150px" }}>Reset</Button>
          </Form.Item>
        </Form>
      </div>
      <div className={ExpressionIIStyle.ExpAnaly_Diffrent_content_Table_Search}>
       <p></p>
        <p>
          <ExcelDownIcon />
        </p>
      </div>
      <Modal
        title={goKey}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <p>{GeneIdText}</p>
      </Modal>
      <Modal
        title={keggKey}
        open={isModalOpenKegg}
        onOk={handleOkKegg}
        onCancel={handleCancelKegg}
      >
        <p>{GeneIdKeggText}</p>
      </Modal>
      <Modal
        title={goKey}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <p>{GeneIdText}</p>
      </Modal>
      <StyledTable
        bordered
        style={{
          width: "100%",
          margin: "10px",
        }}
        columns={DiffColums}
        dataSource={TableData}
        pagination={paginationConfig}
        scroll={{
          x: 3000,
        }}
      />
      <div className={ExpressionIIStyle.ExpAnaly_Diffrent_content_Clustering}>
        <div
          className={
            ExpressionIIStyle.ExpAnaly_Diffrent_content_Clustering_title
          }
        >
          <p>Clustering and Enrichment</p>
          <p></p>
        </div>
        <div
          className={
            ExpressionIIStyle.ExpAnaly_Diffrent_content_Clustering_content
          }
        >
          <div
            className={
              ExpressionIIStyle.ExpAnaly_Diffrent_content_Clustering_content_left
            }
          >
            <p
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "15px",
                fontWeight: "bold",
              }}
            >
              <img src={`${DiffChartSrc.heatmap}`} alt="" />
            </p>
          </div>
          <div
            className={
              ExpressionIIStyle.ExpAnaly_Diffrent_content_Clustering_content_right
            }
          >
            <p
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "15px",
                fontWeight: "bold",
              }}
            >
              <img
                src={`${DiffChartSrc.volcano}`}
                style={{ width: "70%" }}
                alt=""
              />
            </p>
          </div>
        </div>
        <div
          className={
            ExpressionIIStyle.ExpAnaly_Diffrent_content_Clustering_Enrochment
          }
        >
          <div className={ExpressionIIStyle.Diff_go_swiper}>
            <div style={{ width: "78%", height: "100%" }}>
            
              <StyledCarousel
                ref={GoSwiperRef}
                style={{ width: "100%", height: "500px" }}
              >
                {GoImgList?.map((v, i) => {
                  return (
                    <div
                      key={v}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                      }}
                      className="carousel-item"
                    >
                      <img
                        src={`${v}`}
                        style={{
                          height: "500px", // 让图片的高度充满容器
                          margin: "auto",
                        }}
                        alt={`carousel-${v}`}
                      />
                    </div>
                  );
                })}
              </StyledCarousel>
            </div>
            <div
              style={{
                width: "30%",
                height: "400px",
                overflow: "auto",
                whiteSpace: "nowrap",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {GoImgList?.map((v, i) => {
                return (
                  <img
                    src={`${v}`}
                    onClick={() => {
                      GoSwiperRef.current.goTo(i);
                      setGoSwiperCurrent(i);
                    }}
                    style={{
                      width: "90%",
                      height: "auto",
                      margin: "10px 0",
                      display: "inline-block",
                      cursor: "pointer",
                      border: GoSwiperChange(i), // 选中时添加边框
                      transition: "border 0.3s ease-in-out", // 添加过渡效果
                    }}
                  />
                );
              })}
            </div>
          </div>
          <StyledTable2
            style={{ width: "49%", height: "100%" }}
            bordered
            columns={goColums}
            dataSource={goData}
            scroll={{
              x: 2200,
              y: 400,
            }}
          />
        </div>
        <div
          className={
            ExpressionIIStyle.ExpAnaly_Diffrent_content_Clustering_Enrochment
          }
        >
          <div style={{width:"49%",height:"100%",display:"flex",alignItems:"center",justifyContent:"center"}}>
          <img src={`${keggImgList}`} style={{height:"500px",margin:"auto"}} alt="" />
          </div>
           <StyledTable2
            style={{ width: "49%", height: "100%" }}
            bordered
            columns={keggColums}
            dataSource={keggData}
            scroll={{
              x: 2200,
              y: 400,
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default ExpressionII;
